import React, { Component } from 'react';

import withFieldWrapper from 'components/hocs/withFieldWrapper';

class InputHidden extends Component {
    componentDidMount() {
        const { inputValue, input } = this.props;

        if (inputValue && (inputValue !== input.value)) {
            input.onChange(inputValue);
        }
    }

    render() {
        const { input } = this.props;
        return <input {...input} type='hidden' />;
    }
}

export default withFieldWrapper(InputHidden);
